
// // src/pages/Login.jsx
// import React, { useState } from "react";
// import {
//   Avatar,
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   Paper,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   CircularProgress,
//   Link
// } from "@mui/material";

// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";

// import { Link as RouterLink, useNavigate } from "react-router-dom";
// import api from "../utils/api";

// export default function Login() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({ email: "", password: "" });
//   const [showPw, setShowPw] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   function change(e) {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setError("");
//   }

//   async function submit(e) {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const res = await api.post("/auth/login", form);

//       // Save token
//       localStorage.setItem("token", res.data.token);

//       // === FIX CORRUPTED PERMISSIONS ===
//       let userData = res.data.user;

//       // If permissions is a string (corrupted from old data), parse it
//       if (typeof userData.permissions === "string") {
//         try {
//           userData.permissions = JSON.parse(userData.permissions);
//         } catch (parseErr) {
//           console.error("Failed to parse corrupted permissions, resetting to empty", parseErr);
//           userData.permissions = {};
//         }
//       }

//       // Save clean user object
//       // localStorage.setItem("user", JSON.stringify(userData));
// // Save minimal user object INCLUDING team_id
// localStorage.setItem("user", JSON.stringify({
//   id: userData.id,
//   name: userData.name || "User",
//   email: userData.email,
//   role: userData.role,
//   role_caption: userData.role_caption || userData.role,
//   admin_panel_access: userData.admin_panel_access || false,
//  team_id: userData.team_id || null,  // ← THIS LINE FIXES EVERYTHING
// }));
//       // Optional: Force refresh from /auth/me for absolute latest data
//       try {
//         const meRes = await api.get("/auth/me");
//         let freshUser = meRes.data.user;
//         // if (typeof freshUser.permissions === "string") {
//         //   freshUser.permissions = JSON.parse(freshUser.permissions || "{}");
//         // }
//         if (typeof freshUser.permissions === "string") {
//     try {
//       freshUser.permissions = JSON.parse(freshUser.permissions);
//     } catch {
//       freshUser.permissions = {};
//     }
//   }
//         const finalUser = {
//     id: freshUser.id,
//     name: freshUser.name || "User",
//     email: freshUser.email,
//     role: freshUser.role,
//     role_caption: freshUser.role_caption || freshUser.role,
//     admin_panel_access: freshUser.admin_panel_access || false,
//     team_id: userData.team_id || freshUser.team_id || null,  // ← KEEP team_id!
//   };
//         localStorage.setItem("user", JSON.stringify(freshUser));
//       } catch (meErr) {
//         console.warn("Could not refresh from /auth/me, using login data");
//       }

//       navigate("/");
//     } catch (err) {
//       setError(err.response?.data?.message || "Invalid credentials");
//       console.error("Login error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <Container maxWidth="sm" sx={{ mt: 8 }}>
//       <CssBaseline />

//       <Paper
//         elevation={6}
//         sx={{
//           p: 4,
//           borderRadius: 4,
//           textAlign: "center",
//         }}
//       >
//         <Avatar
//           sx={{
//             bgcolor: "#1976d2",
//             width: 56,
//             height: 56,
//             mx: "auto",
//             mb: 2,
//           }}
//         >
//           <LockOutlinedIcon fontSize="large" />
//         </Avatar>

//         <Typography variant="h5" fontWeight={700}>
//           Welcome back
//         </Typography>

//         <Typography sx={{ mb: 3 }} color="text.secondary">
//           Sign in to continue to one desk 
//         </Typography>

//         <Box component="form" onSubmit={submit}>
//           <TextField
//             fullWidth
//             label="Email"
//             name="email"
//             value={form.email}
//             onChange={change}
//             margin="normal"
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 bgcolor: "#eef5ff",
//               },
//             }}
//           />

//           <TextField
//             fullWidth
//             label="Password"
//             name="password"
//             margin="normal"
//             value={form.password}
//             onChange={change}
//             type={showPw ? "text" : "password"}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 bgcolor: "#eef5ff",
//               },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowPw(!showPw)}>
//                     {showPw ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {error && (
//             <Typography color="error" sx={{ mt: 1 }}>
//               {error}
//             </Typography>
//           )}

//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             sx={{
//               mt: 3,
//               py: 1.5,
//               fontSize: "16px",
//               fontWeight: 600,
//               bgcolor: "#1976d2",
//             }}
//           >
//             {loading ? <CircularProgress size={22} sx={{ color: "white" }} /> : "SIGN IN"}
//           </Button>

//           <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
//             <Link component={RouterLink} to="/register" sx={{ fontSize: 14 }}>
//               Create an account
//             </Link>

//             <Link sx={{ fontSize: 14, cursor: "pointer" }}>
//               Forgot password?
//             </Link>
//           </Box>

//           <Typography
//             variant="caption"
//             display="block"
//             sx={{ mt: 3 }}
//             color="text.secondary"
//           >
//             By continuing you agree to SiteWorks terms & privacy.
//           </Typography>
//         </Box>
//       </Paper>
//     </Container>
//   );
// }

// // src/pages/Login.jsx
// import React, { useState } from "react";
// import {
//   Avatar,
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   Paper,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   CircularProgress,
//   Link,
//   useTheme,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";

// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";

// import { Link as RouterLink, useNavigate } from "react-router-dom";
// import api from "../utils/api";

// // Custom styled components for advanced look
// const GradientBackground = styled(Box)({
//   minHeight: "100vh",
//   background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   position: "relative",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: "radial-gradient(circle at 30% 70%, rgba(102, 126, 234, 0.4), transparent 50%)",
//     pointerEvents: "none",
//   },
// });

// const GlassCard = styled(Paper)(({ theme }) => ({
//   background: "rgba(255, 255, 255, 0.85)",
//   backdropFilter: "blur(16px)",
//   borderRadius: "28px",
//   padding: theme.spacing(6),
//   width: "100%",
//   maxWidth: "440px",
//   boxShadow: "0 24px 60px rgba(0, 0, 0, 0.2)",
//   border: "1px solid rgba(255, 255, 255, 0.3)",
//   position: "relative",
//   overflow: "hidden",
// }));

// const GradientAvatar = styled(Avatar)(({ theme }) => ({
//   width: 80,
//   height: 80,
//   margin: "0 auto 24px",
//   background: "linear-gradient(135deg, #1976d2, #42a5f5)",
//   boxShadow: "0 12px 30px rgba(25, 118, 210, 0.4)",
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(2),
//   fontSize: "17px",
//   fontWeight: 600,
//   borderRadius: "16px",
//   background: "linear-gradient(90deg, #1976d2, #42a5f5)",
//   boxShadow: "0 8px 25px rgba(25, 118, 210, 0.35)",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     transform: "translateY(-3px)",
//     boxShadow: "0 12px 35px rgba(25, 118, 210, 0.5)",
//     background: "linear-gradient(90deg, #1565c0, #1e88e5)",
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   marginBottom: theme.spacing(2.5),
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "16px",
//     background: "rgba(241, 245, 249, 0.7)",
//     transition: "all 0.3s ease",
//     "&:hover": {
//       background: "rgba(241, 245, 249, 0.9)",
//     },
//     "&.Mui-focused": {
//       background: "rgba(255, 255, 255, 0.95)",
//       boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.2)",
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": {
//     color: "#1976d2",
//   },
// }));

// export default function Login() {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [form, setForm] = useState({ email: "", password: "" });
//   const [showPw, setShowPw] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const change = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setError("");
//   };

//   // Your existing submit logic remains unchanged
//   async function submit(e) {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const res = await api.post("/auth/login", form);
//       localStorage.setItem("token", res.data.token);

//       let userData = res.data.user;

//       if (typeof userData.permissions === "string") {
//         try {
//           userData.permissions = JSON.parse(userData.permissions);
//         } catch {
//           userData.permissions = {};
//         }
//       }

//       localStorage.setItem("user", JSON.stringify({
//         id: userData.id,
//         name: userData.name || "User",
//         email: userData.email,
//         role: userData.role,
//         role_caption: userData.role_caption || userData.role,
//         admin_panel_access: userData.admin_panel_access || false,
//         team_id: userData.team_id || null,
//       }));

//       // Optional refresh from /auth/me...
//       // (your existing code)

//       navigate("/");
//     } catch (err) {
//       setError(err.response?.data?.message || "Invalid credentials");
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <>
//       <CssBaseline />
//       <GradientBackground>
//         <GlassCard elevation={0}>
//           <GradientAvatar>
//             <LockOutlinedIcon sx={{ fontSize: 40 }} />
//           </GradientAvatar>

//           <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
//             Welcome back
//           </Typography>

//           <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
//             Sign in to continue to one desk
//           </Typography>

//           <Box component="form" onSubmit={submit}>
//             <StyledTextField
//               fullWidth
//               label="Email"
//               name="email"
//               type="email"
//               value={form.email}
//               onChange={change}
//               required
//               variant="outlined"
//             />

//             <StyledTextField
//               fullWidth
//               label="Password"
//               name="password"
//               type={showPw ? "text" : "password"}
//               value={form.password}
//               onChange={change}
//               required
//               variant="outlined"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPw(!showPw)} edge="end">
//                       {showPw ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {error && (
//               <Typography color="error" sx={{ mt: 1, mb: 2 }}>
//                 {error}
//               </Typography>
//             )}

//             <StyledButton
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={28} color="inherit" /> : "SIGN IN"}
//             </StyledButton>

//             <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//               <Link component={RouterLink} to="/register" underline="hover" color="primary">
//                 Create an account
//               </Link>
//               <Link underline="hover" color="text.secondary" sx={{ cursor: "pointer" }}>
//                 Forgot password?
//               </Link>
//             </Box>

//             <Typography variant="caption" display="block" sx={{ mt: 4, color: "text.secondary" }}>
//               By continuing you agree to SiteWorks terms & privacy.
//             </Typography>
//           </Box>
//         </GlassCard>
//       </GradientBackground>
//     </>
//   );
// }

// // src/pages/Login.jsx
// import React, { useState } from "react";
// import {
//   Avatar,
//   Box,
//   Button,
//   Container,
//   CssBaseline,
//   Paper,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   CircularProgress,
//   Link,
//   useTheme,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";

// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";

// import { Link as RouterLink, useNavigate } from "react-router-dom";
// import api from "../utils/api";

// // Import your logo (adjust path if necessary)
// import Logo from "../assets/images/Logo.png"; // ← Add your Logo.png here

// // Orange-themed styled components
// const GradientBackground = styled(Box)({
//   minHeight: "100vh",
//   background: "linear-gradient(135deg, #FF6B35 0%, #F7931E 50%, #FF8C42 100%)", // Vibrant orange mix
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   position: "relative",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: "radial-gradient(circle at 30% 70%, rgba(255, 140, 66, 0.5), transparent 50%)",
//     pointerEvents: "none",
//   },
// });

// const GlassCard = styled(Paper)(({ theme }) => ({
//   background: "rgba(255, 255, 255, 0.92)",
//   backdropFilter: "blur(16px)",
//   borderRadius: "28px",
//   padding: theme.spacing(6),
//   width: "100%",
//   maxWidth: "440px",
//   boxShadow: "0 24px 60px rgba(255, 107, 53, 0.25)", // Orange-tinted shadow
//   border: "1px solid rgba(255, 255, 255, 0.4)",
//   position: "relative",
//   overflow: "hidden",
// }));

// const LogoAvatar = styled(Avatar)(({ theme }) => ({
//   width: 90,
//   height: 90,
//   margin: "0 auto 24px",
//   padding: 8,
//   background: "rgba(255, 255, 255, 0.9)",
//   boxShadow: "0 12px 35px rgba(255, 107, 53, 0.4)", // Orange glow
//   "& img": {
//     objectFit: "contain",
//   },
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(2),
//   fontSize: "17px",
//   fontWeight: 600,
//   borderRadius: "16px",
//   background: "linear-gradient(90deg, #FF6B35, #F7931E)",
//   boxShadow: "0 8px 25px rgba(255, 107, 53, 0.4)",
//   color: "white",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     transform: "translateY(-3px)",
//     boxShadow: "0 14px 40px rgba(255, 107, 53, 0.55)",
//     background: "linear-gradient(90deg, #FF5218, #E67E00)",
//   },
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   marginBottom: theme.spacing(2.5),
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "16px",
//     background: "rgba(255, 245, 240, 0.8)", // Warm light background
//     transition: "all 0.3s ease",
//     "&:hover": {
//       background: "rgba(255, 245, 240, 0.95)",
//     },
//     "&.Mui-focused": {
//       background: "rgba(255, 255, 255, 0.98)",
//       boxShadow: "0 0 0 3px rgba(255, 107, 53, 0.3)",
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": {
//     color: "#FF6B35",
//   },
// }));

// export default function Login() {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [form, setForm] = useState({ email: "", password: "" });
//   const [showPw, setShowPw] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const change = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//     setError("");
//   };

//   async function submit(e) {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     try {
//       const res = await api.post("/auth/login", form);
//       localStorage.setItem("token", res.data.token);

//       let userData = res.data.user;

//       if (typeof userData.permissions === "string") {
//         try {
//           userData.permissions = JSON.parse(userData.permissions);
//         } catch {
//           userData.permissions = {};
//         }
//       }

//       localStorage.setItem("user", JSON.stringify({
//         id: userData.id,
//         name: userData.name || "User",
//         email: userData.email,
//         role: userData.role,
//         role_caption: userData.role_caption || userData.role,
//         admin_panel_access: userData.admin_panel_access || false,
//         team_id: userData.team_id || null,
//       }));

//       navigate("/");
//     } catch (err) {
//       setError(err.response?.data?.message || "Invalid credentials");
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <>
//       <CssBaseline />
//       <GradientBackground>
//         <GlassCard elevation={0}>
//           <LogoAvatar>
//             <img src={Logo} alt="1D Logo" style={{ width: "100%", height: "100%" }} />
//           </LogoAvatar>

//           <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
//             Welcome back
//           </Typography>

//           <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
//             Sign in to continue to one desk
//           </Typography>

//           <Box component="form" onSubmit={submit}>
//             <StyledTextField
//               fullWidth
//               label="Email"
//               name="email"
//               type="email"
//               value={form.email}
//               onChange={change}
//               required
//               variant="outlined"
//             />

//             <StyledTextField
//               fullWidth
//               label="Password"
//               name="password"
//               type={showPw ? "text" : "password"}
//               value={form.password}
//               onChange={change}
//               required
//               variant="outlined"
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton onClick={() => setShowPw(!showPw)} edge="end">
//                       {showPw ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             {error && (
//               <Typography color="error" sx={{ mt: 1, mb: 2 }}>
//                 {error}
//               </Typography>
//             )}

//             <StyledButton
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={28} color="inherit" /> : "SIGN IN"}
//             </StyledButton>

//             <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//               {/* <Link component={RouterLink} to="/register" underline="hover" color="primary">
//                 Create an account
//               </Link> */}
//               <Link underline="hover" color="text.secondary" sx={{ cursor: "pointer" }}>
//                 Forgot password?
//               </Link>
//             </Box>

//             <Typography variant="caption" display="block" sx={{ mt: 4, color: "text.secondary" }}>
//               {/* By continuing you agree to OneDesk terms & privacy. */}
//             </Typography>
//           </Box>
//         </GlassCard>
//       </GradientBackground>
//     </>
//   );
// }

// src/pages/Login.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Paper,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  CircularProgress,
  Link,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { Link as RouterLink, useNavigate } from "react-router-dom";
import api from "../utils/api";

// Import your logo (adjust path if necessary)
import Logo from "../assets/images/Logo.png"; // ← Make sure this path is correct

// Orange-themed styled components
const GradientBackground = styled(Box)({
  minHeight: "100vh",
  background: "linear-gradient(135deg, #FF6B35 0%, #F7931E 50%, #FF8C42 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "radial-gradient(circle at 30% 70%, rgba(255, 140, 66, 0.5), transparent 50%)",
    pointerEvents: "none",
  },
});

const GlassCard = styled(Paper)(({ theme }) => ({
  background: "rgba(255, 255, 255, 0.92)",
  backdropFilter: "blur(16px)",
  borderRadius: "28px",
  padding: theme.spacing(6),
  width: "100%",
  maxWidth: "440px",
  boxShadow: "0 24px 60px rgba(255, 107, 53, 0.25)",
  border: "1px solid rgba(255, 255, 255, 0.4)",
  position: "relative",
  overflow: "hidden",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  fontSize: "17px",
  fontWeight: 600,
  borderRadius: "16px",
  background: "linear-gradient(90deg, #FF6B35, #F7931E)",
  boxShadow: "0 8px 25px rgba(255, 107, 53, 0.4)",
  color: "white",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 14px 40px rgba(255, 107, 53, 0.55)",
    background: "linear-gradient(90deg, #FF5218, #E67E00)",
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    background: "rgba(255, 245, 240, 0.8)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(255, 245, 240, 0.95)",
    },
    "&.Mui-focused": {
      background: "rgba(255, 255, 255, 0.98)",
      boxShadow: "0 0 0 3px rgba(255, 107, 53, 0.3)",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#FF6B35",
  },
}));

export default function Login() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const change = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await api.post("/auth/login", form);
      localStorage.setItem("token", res.data.token);

      let userData = res.data.user;

      if (typeof userData.permissions === "string") {
        try {
          userData.permissions = JSON.parse(userData.permissions);
        } catch {
          userData.permissions = {};
        }
      }

      localStorage.setItem("user", JSON.stringify({
        id: userData.id,
        name: userData.name || "User",
        email: userData.email,
        role: userData.role,
        role_caption: userData.role_caption || userData.role,
        admin_panel_access: userData.admin_panel_access || false,
        team_id: userData.team_id || null,
      }));

      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <CssBaseline />
      <GradientBackground>
        <GlassCard elevation={0}>
          {/* Updated logo – clean rectangular instead of circle */}
          <Box sx={{ mb: 4, textAlign: "center" }}>
            <img
              src={Logo}
              alt="OneDesk Logo"
              style={{
                maxWidth: "220px",      // ← adjust this value to fit your logo nicely
                height: "auto",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Box>

          <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
            Welcome back
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Sign in to one desk
          </Typography>

          <Box component="form" onSubmit={submit}>
            <StyledTextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={form.email}
              onChange={change}
              required
              variant="outlined"
            />

            <StyledTextField
              fullWidth
              label="Password"
              name="password"
              type={showPw ? "text" : "password"}
              value={form.password}
              onChange={change}
              required
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPw(!showPw)} edge="end">
                      {showPw ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {error && (
              <Typography color="error" sx={{ mt: 1, mb: 2 }}>
                {error}
              </Typography>
            )}

            <StyledButton
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
            >
              {loading ? <CircularProgress size={28} color="inherit" /> : "SIGN IN"}
            </StyledButton>

            <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
              {/* Uncomment if you want registration link */}
              {/* <Link component={RouterLink} to="/register" underline="hover" color="primary">
                Create an account
              </Link> */}
              <Link underline="hover" color="text.secondary" sx={{ cursor: "pointer" }}>
                Forgot password?
              </Link>
            </Box>

            <Typography variant="caption" display="block" sx={{ mt: 4, color: "text.secondary" }}>
              {/* By continuing you agree to OneDesk terms & privacy. */}
            </Typography>
          </Box>
        </GlassCard>
      </GradientBackground>
    </>
  );
}